import axios from 'axios';
import { apiServerHost } from '../../../common/APIServerSettings';
import { DEV_API_FLAG } from '../../../common/API';

const editEntity_0 = (callBack, errorCallBack, entityId, type=0, name, value, language) => {
  const params = new URLSearchParams();
  params.append("entityID", entityId);
  params.append("entityName", name);
  params.append("entityValue", value);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  
  const temp_params = {
    entityID : entityId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : value,
  }
  const stringify_params = JSON.stringify(temp_params);

  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}update/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response);
  })
}

const editEntity_1 = (callBack, errorCallBack, entityId, type=1, name, value, language) => {
  const params = new URLSearchParams();
  params.append("entityID", entityId);
  params.append("entityName", name);
  params.append("entityValue", value);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  
  
  
  
  

  const temp_params = {
    entityID : entityId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : [value],
  }
  const stringify_params = JSON.stringify(temp_params);

  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}update/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response);
  })
}

const editEntity_2 = (callBack, errorCallBack, entityId, type=2, name, value, language, entity_func) => {
  const params = new URLSearchParams();
  params.append("entityID", entityId);
  params.append("entityName", name);
  params.append("entityValue", value);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  params.append("entityFunction", entity_func);
  
  const temp_params = {
    entityID : entityId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : [value],
    entityFunction : entity_func,
  }
  const stringify_params = JSON.stringify(temp_params);

  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}update/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response);
  })
}

const editEntity_3 = (callBack, errorCallBack, entityId, type=3, name, language, entities) => {
  
  let memberEntities_toParam = entities.map( memberEntity => {
    if (memberEntity.type === -1) {
      return {
        val : memberEntity.value,
        type : -1,
      }
    }
    return {
      id : memberEntity.id,
      type : memberEntity.type,
    }
  })
  
  const params = new URLSearchParams();
  params.append("entityID", entityId);
  params.append("entityName", name);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  
  const temp_params = {
    entityID : entityId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entities : memberEntities_toParam,
  }
  const stringify_params = JSON.stringify(temp_params);
  
  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}update/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response);
  })
}

export {editEntity_0};
export {editEntity_1};
export {editEntity_2};
export {editEntity_3};